// extracted by mini-css-extract-plugin
export default {"loader":"folder_drop_loading-module__loader--3Ndvr"};